import { render } from "./PaymentSummaryRowItemsByFormType.vue?vue&type=template&id=b573e064&scoped=true&ts=true"
import script from "./PaymentSummaryRowItemsByFormType.vue?vue&type=script&lang=ts"
export * from "./PaymentSummaryRowItemsByFormType.vue?vue&type=script&lang=ts"

import "./PaymentSummaryRowItemsByFormType.vue?vue&type=style&index=0&id=b573e064&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b573e064"]])

export default __exports__